document.addEventListener("DOMContentLoaded", function () {
        const accordions = document.querySelectorAll('.accordion');

        accordions.forEach((accordion) => {
            const toggle = accordion.querySelector('.accordion-toggle');
            const panel = accordion.querySelector('.accordion-panel');

            toggle.addEventListener('click', function () {
                const isOpen = accordion.classList.contains('open');
                closeAllAccordions();
                if (!isOpen) {
                    accordion.classList.add('open');
                    setPanelHeight(panel);
                } else {
                    accordion.classList.remove('open');
                    panel.style.height = '0';
                }
            });
        });

        function closeAllAccordions() {
            accordions.forEach((accordion) => {
                accordion.classList.remove('open');
                const panel = accordion.querySelector('.accordion-panel');
                panel.style.height = '0';
            });
        }

        function setPanelHeight(panel) {
            const content = panel.querySelector('.accordion-content');
            const contentHeight = content.offsetHeight;
            panel.style.height = `${contentHeight}px`;
        }

        // Add event listener for window resize
        window.addEventListener('resize', function () {
            // Loop through each accordion
            accordions.forEach((accordion) => {
                // Get the panel of the accordion
                const panel = accordion.querySelector('.accordion-panel');
                // If the accordion is open, adjust its panel height
                if (accordion.classList.contains('open')) {
                    setPanelHeight(panel);
                }
            });
        });
    });